import { format } from 'date-fns';

export const calculateStartDate = (grandOpening: string, hasAtav = false) => {
  if (hasAtav) {
    return null;
  }

  if (new Date(grandOpening) > new Date()) {
    return format(new Date(grandOpening), 'yyyy-MM-dd');
  }

  return null;
};

export const formatLocation = ({
  uid = '',
  name = '',
  grand_opening = '',
  soft_opening = '',
  machine_type = 0,
} = {}) => ({
  uid,
  name,
  grand_opening,
  soft_opening,
  machine_type,
});
